import { setConfig, isInitialized } from './core/config';
import { getStatus, clearProof } from './core/state';
import { VerenaInline } from './ui/inline';
import type { VerenaConfig, VerenaProof, VerenaStatus } from './core/config';

/**
 * Initialize Verena with your site configuration.
 */
export function init(config: VerenaConfig): void {
  setConfig(config);
}

/**
 * Mount an inline verification widget into a container element.
 * The widget renders inside an iframe pointing to Verena's domain.
 */
export function mount(container: Element | string): void {
  if (!isInitialized()) {
    throw new Error('Verena: not initialized. Call Verena.init() first.');
  }
  const inline = new VerenaInline();
  inline.mount(container);
}

/**
 * Check if the current user has a valid proof.
 */
export function status(): VerenaStatus {
  return getStatus();
}

/**
 * Clear the stored proof (e.g. on logout).
 */
export function reset(): void {
  clearProof();
}

// Grouped namespace export for ESM consumers: import { Verena } from "@verena/js"
export const Verena = { init, mount, status, reset };

// Re-export types
export type { VerenaConfig, VerenaProof, VerenaStatus };
